import _ from 'lodash';
import { Dispatch, Ref, SetStateAction, useState } from 'react';
import { Col, Row, Spinner } from 'react-bootstrap';
import { useParams } from 'react-router-dom';
import { IMessage } from '../../commons/interfaces/chat.interface';
import { IChatbotAPIPagination } from '../../commons/interfaces/chatbotAPI.interface';
import Message from '../../components/Message';
import ChatbotAPI from '../../services/chatbot.service';

interface MessageListProps {
  messages: IMessage[];
  addOldMessages: (oldMessages: IMessage[]) => void;
  pagination: IChatbotAPIPagination;
  setPagination: Dispatch<SetStateAction<IChatbotAPIPagination>>;
  bottomRef: Ref<HTMLDivElement>;
}

const chatbotAPI = new ChatbotAPI();

const MessageList = ({
  messages,
  addOldMessages,
  pagination,
  setPagination,
  bottomRef
}: MessageListProps) => {
  const params = useParams();

  const [chatLoading, setChatLoading] = useState(false);

  const handleScroll = async (ev: any) => {
    if (ev.target.scrollTop === 0 && pagination.page < pagination.pageCount) {
      setChatLoading(true);

      const nextPage = pagination.page + 1;
      const response = await chatbotAPI.listTicketMessages(params.ticketId as string, nextPage);

      addOldMessages(response.data);
      setPagination(response.pagination);
      ev.target.scrollTo(0, 100);

      setChatLoading(false);
    }
  };

  const ChatLoading = () => (
    <div className="container-loader chat-loading">
      <div className="loader">
        <Spinner animation="border" />
      </div>
    </div>
  );

  return (
    <>
      {chatLoading && <ChatLoading />}
      <Row className="px-2 chat-body flex-column" onScroll={handleScroll}>
        <Row className="flex-column-reverse">
          {_.map(messages, (message, idx) => (
            <Col key={idx}>
              <Message message={message} />
              {idx === 0 && <div ref={bottomRef} />}
            </Col>
          ))}
        </Row>
      </Row>
    </>
  );
};

export default MessageList;
